"use client";

import { AuthSessionData } from "@cartz/auth";
import { useEffect } from "react";
import { FullPageError } from "./full-page-error";

export const ErrorPage = ({
  authSession,
  error,
}: {
  authSession: AuthSessionData;
  error: string;
}) => {
  useEffect(() => {
    console.error(
      `Error occurred: ${error} for auth session: ${authSession.session.id}`,
    );
  }, [authSession.session.id, error]);

  return (
    <FullPageError
      description={
        <>
          Please try again later or contact us at{" "}
          <a
            className="font-medium text-primary underline-offset-4 hover:underline"
            href="mailto:info@getjurni.ai"
          >
            info@getjurni.ai
          </a>
        </>
      }
    />
  );
};
